import {
  API_TYPES,
  PostSpendingControlValidationBodySchema,
  SpendingControlValidationResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { type TimeSlot } from "@src/appV2/Shifts/types";
import { useMutation } from "@tanstack/react-query";

interface SpendingControlShiftInput {
  start: Date;
  end: Date;
  requirement: string;
  timeSlot: TimeSlot;
}

interface ValidateSpendingControlParams {
  workplaceId: string;
  shifts: SpendingControlShiftInput[];
}

export function useValidateSpendingControl() {
  return useMutation({
    mutationFn: async (params: ValidateSpendingControlParams) => {
      const { workplaceId, shifts } = params;

      const url = `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/spending-control-validations`;

      const response = await post({
        url,
        data: {
          data: {
            type: API_TYPES.spendingControlValidation,
            attributes: {
              shifts,
            },
            relationships: {
              workplace: {
                data: {
                  type: API_TYPES.workplace,
                  id: workplaceId,
                },
              },
            },
          },
        },
        bodySchema: PostSpendingControlValidationBodySchema,
        responseSchema: SpendingControlValidationResponseSchema,
      });

      return response.data.data.attributes;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.VALIDATE_SPENDING_CONTROL_FAILURE,
    },
  });
}
